import { VoteType, GetReviewsQuery } from '@notino/shared/definitions/types';

export const canBeVoted = (
  review: NonNullable<
    NonNullable<GetReviewsQuery['reviewsAndFilters']>['data']
  >['reviews'][number],
  likeDislike: string
) =>
  (!review.alreadyLiked && !review.alreadyDisliked) ||
  (review.alreadyLiked && likeDislike === VoteType.Like) ||
  (review.alreadyDisliked && likeDislike === VoteType.Dislike);
